(ns common.schema.entities.decision-one-pager
  (:require
   [common.schema.entities.decision-options :as decision-opts]
   [common.schema.schema-utils :as su]))

(def schema
  (concat
   (su/date-field :decision/date
                  "Date"
                  {:authorization su/access-user-user
                   :default-field-visibility :in-use})

   (su/keyword-field :decision/approval-status
                     "Status"
                     decision-opts/approval-status-options
                     {:default-field-visibility :in-use})

   (su/text-multiline-field :decision/notes
                            "Notes"
                            {:default-field-visibility :in-use})))
